import { defineComponent as _defineComponent } from 'vue'
import DialogLayout from '@/components/common/DialogLayout.vue';
import { Contact } from '@/models/dto/ContactGroup';
import { ContactAction, ContactType, getContactServiceCall } from './utils/helpers';
import { computed, getCurrentInstance, ref } from 'vue';
import alert from "@/store/modules/alert";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmRemoveContactDialog',
  props: {
    value: { type: Boolean },
    contactToRemove: null,
    contactType: null,
    entityId: null
  },
  emits: ['cancel', 'confirm', 'refresh', 'update:value'],
  setup(__props: any, { emit }) {

const props = __props as {
  value: boolean;
  contactToRemove: Contact;
  contactType: ContactType
  entityId: number
};

const { proxy } = getCurrentInstance()!;
const t = proxy.$t.bind(proxy);





const isSubmitting = ref<boolean>(false);

const cancelRemoveContact = () => {
    emit('update:value', false);
    emit('cancel');
}

const confirmRemoveContact = async () => {
  isSubmitting.value = true;
  const removeContactFn = getContactServiceCall(props.contactType, ContactAction.Remove)
  try {
    await removeContactFn(props.entityId, props.contactToRemove.externalId!);
    alert.add({
      text: "",
      color: "success",
      title: "Removed",
      dismissible: true,
    });
    emit('refresh');
  } catch (error: any) {
    console.error(`Removing Contact ${props.contactToRemove.externalId} from reservationDetailContactInfo reservation: ${props.entityId} failed: ${error.response.data.message}`);
    alert.add({
      text: "",
      color: "error",
      title: "Delete failed",
      dismissible: true,
    });
  } finally {
    emit('update:value', false);
    isSubmitting.value = false;
    emit('confirm');
  }
}

const removeConfirmationText = computed(() => {
  const name = props.contactToRemove?.name || props.contactToRemove?.email || ''
  return props.contactType === ContactType.Reservation
    ? t('tripContact.REMOVE_CONFIRMATION_RESERVATION', { name })
    : t('tripContact.REMOVE_CONFIRMATION_QUOTE', { name })
})


return { __sfc: true,proxy, t, props, emit, isSubmitting, cancelRemoveContact, confirmRemoveContact, removeConfirmationText, DialogLayout }
}

})